<div class="flex justify-between">
  <p class="text-3xl font-bold text-gray-90 w-max">{{ pageTitle.title }}</p>

  <button
    *ngIf="pageTitle.showButton"
    routerLink="{{ pageTitle.buttonLink }}"
    type="button"
    class="text-gray-900 bg-white hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-3 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-500 mb-2"
  >
    <ng-icon name="{{ pageTitle.buttonIcon }}" class="mr-2"></ng-icon>

    {{ pageTitle.buttonText }}
  </button>
</div>

<hr class="h-px my-4 bg-gray-200 border-0 dark:bg-gray-700" />
